<template>
  <v-expansion-panels v-model="paramter_panel" accordion class="accordion">

    <!-- paramter_panel[0]: corpus -->
    <v-expansion-panel v-if="visible_panel.indexOf('corpus') !== -1">
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.train.corpus_for_training") }}
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                {{ make_title('corpus') }}
              </span>
              <span v-if="!open && !make_title('corpus')" class="text--secondary">
                {{ $t("message.common.select_text") }}
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-tabs
          background-color="primary"
          dark
          v-model="corpus_tab"
          @change="reset_corpus_tab"
        >
          <v-tab href="#new_corpus">
            {{ $t("message.train.new_corpus") }}
          </v-tab>
          <v-tab href="#uploaded_corpus">
            {{ $t("message.train.existing_corpus") }}
          </v-tab>
          <v-tab href="#translated">
            {{ $t("message.common.translated") }}
          </v-tab>

          <!-- corpus_tab[0]: new_corpus -->
          <v-tabs-items v-model="corpus_tab">
            <v-tab-item value="new_corpus">
              <v-card class="pa-5">
                <Upload
                  ref="upload_corpus"
                  type="corpus"
                  :valid="corpuses_valid"
                  :multiple="false"
                  :max_files="1"
                  v-on:update_files="corpuses = $event"
                  v-on:update_files_valid="corpuses_valid = $event"
                  v-on:done_upload="$emit('done_upload_corpus', $event)"
                  :upload_detail="upload_detail_parm_corpus"
                >
                </Upload>
                <template v-if="get_extension() === 'xlsx'">
                  <LangPairSelect
                    :lang_pair="xlsx_lang_pair"
                    v-on:update_lang_pair="xlsx_lang_pair = $event"
                    :lang_pairs="$store.getters.lang_pairs['trainable']"
                    display_type="first_second"
                  ></LangPairSelect>
                </template>
              </v-card>
            </v-tab-item>

            <!-- corpus_tab[1]: uploaded_corpus -->
            <v-tab-item value="uploaded_corpus">
              <v-card class="mb-1 mt-1">
                <CorpusSelect
                  ref="corpus_select"
                  :selected_corpus="uploaded_corpuses"
                  :multiple="true"
                  :select_one="true"
                  :max_select="5"
                  :show_select="true"
                  :initital_cid="uploaded_corpuses.length > 0 ? uploaded_corpuses[0].cid : ''"
                  v-on:update_corpuses_select="uploaded_corpuses = $event"
                  :mode="mode"
                  :file_remarks="file_remarks"
                  :lang_pair="corpus_lang_pair"
                ></CorpusSelect>
              </v-card>
            </v-tab-item>

            <!-- corpus_tab[2]: translated -->
            <v-tab-item value="translated">
              <v-card class="mb-1 mt-1">
                <FileSelect
                  ref="translated_select"
                  :nid="$store.getters.user.nid"
                  :uid="$store.getters.user.uid"
                  :selected_file="translateds"
                  file_type="translated"
                  extension_type="json"
                  :own_only="false"
                  :multiple="true"
                  :select_one="true"
                  :max_select="5"
                  :show_select="true"
                  initital_fid=""
                  v-on:update_files_select="translateds = $event"
                  :operations="['preview']"
                  :lang_pair="translated_lang_pair"
                ></FileSelect>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- paramter_panel[1]: title -->
    <v-expansion-panel v-if="visible_panel.indexOf('title') !== -1">
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.common.title") }}
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                {{ make_title('title') }}
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-text-field
          :label="$t('message.common.title')"
          v-model="parameters.title"
          :rules="[
            v => v && v.length <= 80 || $t('message.common.over_text', { length: 80 })
          ]"
          counter="80"
        >
        </v-text-field>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- paramter_panel[2]: command -->
    <template v-if="purposes.length > 1">
      <v-expansion-panel v-if="visible_panel.indexOf('command') !== -1">
        <v-expansion-panel-header>
          <template v-slot:default="{ open }">
            <v-row>
              <v-col cols="4">
                {{ $t("message.common.command") }}
              </v-col>
              <v-col cols="8">
                <span v-if="!open">
                  {{ $t("message.common.purpose") }}={{ $t("message.common.purpose_" + parameters.purpose) }}
                </span>
              </v-col>
            </v-row>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-select
            :label="$t('message.common.purpose')"
            :items="purposes"
            item-text="label"
            item-value="value"
            v-model="parameters.purpose"
          >
            <template v-slot:item="props">
              {{ $t('message.common.purpose_' + props.item.label) }}
            </template>
            <template v-slot:selection="props">
              {{ $t('message.common.purpose_' + props.item.label) }}
            </template>
          </v-select>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>

    <!-- paramter_panel[3]: lang_pair -->
    <v-expansion-panel v-if="visible_panel.indexOf('lang_pair') !== -1">
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.common.language") }}
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                {{ $t("message.common.lang_" + parameters.source_lang) }}
                &rarr;
                {{ $t("message.common.lang_" + parameters.target_lang) }}
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <LangPairSelect
          :lang_pair="train_lang_pair"
          v-on:update_lang_pair="train_lang_pair = $event; set_field()"
          :lang_pairs="train_lang_pairs"
          display_type="source_target"
        ></LangPairSelect>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- paramter_panel[4]: field -->
    <v-expansion-panel v-if="visible_panel.indexOf('field') !== -1">
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.train.base_model_for_training") }}
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                <template v-if="selected_field.length > 0">
                  {{ selected_field.length > 0 ? (field_property(selected_field[0], "name") + "(" + selected_field[0] + ")") : "" }}
                </template>
              </span>
              <span v-if="!open && selected_field.length <= 0" class="text--secondary">
                {{ $t("message.common.select_text") }}
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card>
          <v-card-text>
            <div class="d-flex flex-wrap pa-3">
              <div>
                {{ $t("message.common.selecting_field") }}：
              </div>
              <div>
                {{ selected_field.length > 0 ? field_property(selected_field[0], "name") : "" }}
              </div>
            </div>
            <FieldSelect
              ref="field_select"
              :source_lang="parameters.source_lang"
              :target_lang="parameters.target_lang"
              type="trainable"
              :selected_field="selected_field"
              v-on:update_selected_field="selected_field = $event"
              class="body-2 mt-1"
            ></FieldSelect>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- paramter_panel[5]: detail -->
    <v-expansion-panel v-if="visible_panel.indexOf('detail') !== -1
      && (fisher_multiplier_available)">
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.train.detail") }}
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                <template v-if="fisher_multiplier_available">
                  λ={{ (10 ** lambda).toFixed(0) }}
                </template>
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <!-- fisher_multiplier -->
        <v-card class="d-flex" flat>
          <v-slider
            label="λ"
            v-model="lambda"
            :max="10"
            :step="0.1"
            thumb-label="always"
            @change="parameters.detail.fisher_multiplier = Math.floor(10 ** $event)"
          ></v-slider>
          {{ (10 ** lambda).toFixed(0) }}
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- paramter_panel[6]: source(option) -->
    <v-expansion-panel v-if="visible_panel.indexOf('source') !== -1">
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.train.select") }}
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon class="mb-1 ml-3" size="16" v-on="on">
                    mdi-help-circle-outline
                </v-icon>
                </template>
                <span>
                  {{ $t("message.train.select_desc1") }}<br />
                  {{ $t("message.train.select_desc2", { max_corpus: "10,000" }) }}
                </span>
              </v-tooltip>
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                {{ make_title('source') }}
              </span>
              <span v-if="!open && !make_title('source')" class="text--secondary">
                {{ $t("message.train.no_select_corpus") }}
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card outlined>
          <v-tabs
            background-color="primary"
            dark
            v-model="source_tab"
            @change="reset_source_tab"
          >
            <v-tab href="#new_file">
              {{ $t("message.common.new_file") }}
            </v-tab>
            <v-tab href="#uploaded_file">
              {{ $t("message.common.uploaded_file") }}
            </v-tab>

            <!-- source_tab[0]: new_file -->
            <v-tabs-items v-model="source_tab">
              <v-tab-item value="new_file">
                <v-card class="pa-5">
                  <Upload
                    ref="upload_source"
                    type="source"
                    page="train"
                    :valid="files_valid"
                    :multiple="false"
                    :max_files="1"
                    v-on:update_files_valid="files_valid = $event"
                    v-on:done_upload="$emit('done_upload_source', $event)"
                    :upload_detail="upload_detail_parm_source"
                  >
                  </Upload>
                </v-card>
              </v-tab-item>

              <!-- source_tab[1]: uploaded_file -->
              <v-tab-item value="uploaded_file">
                <v-card class="mb-1 mt-1">
                  <FileSelect
                    ref="file_select"
                    :selected_file="uploaded_files"
                    file_type="source"
                    :multiple="false"
                    :select_one="true"
                    :max_select="1"
                    :show_select="true"
                    :initital_fid="uploaded_files.length > 0 ? uploaded_files[0].fid : ''"
                    v-on:update_files_select="uploaded_files = $event"
                  ></FileSelect>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import Upload from '../components/Upload';
import LangPairSelect from '../components/LangPairSelect';
import FieldSelect from '../components/FieldSelect';
import CorpusSelect from '../components/CorpusSelect';
import FileSelect from '../components/FileSelect';
import { http_error } from "../js/http_error";

export default {
  name: 'train_parameter',
  components: {
    Upload,
    LangPairSelect,
    FieldSelect,
    CorpusSelect,
    FileSelect
  },
  mixins: [http_error],
  props: {
    visible_panel: Array,
  },
  data: function(){
    var purposes = [];
    var purpose = "standard";
    if(this.$store.getters.user && this.$store.getters.user.allowed_purposes){
      for(var p of this.$store.getters.user.allowed_purposes){
        purposes.push({
          label: p,
          value: p
        });
      }
      if(this.$store.getters.user.allowed_purposes.indexOf("standard") < 0
        && this.$store.getters.user.allowed_purposes.length > 0){
        purpose = this.$store.getters.user.allowed_purposes[0];
      }
    }
    if(purposes.length === 0){
      purposes.push({
        label: "standard",
        value: "standard"
      });
    }
    return {
      module_id: "76",
      mode: "user",
      // common
      paramter_panel: 0,
      parameters: {
        corpus: null,
        corpus_type: null,
        source: null,
        source_type: "none",
        title: "",
        //night_reserve: false,
        first_lang: "en",
        second_lang: "ja",
        source_lang: "en",
        target_lang: "ja",
        field: "L000001",
        purpose: purpose,
        detail: {
          fisher_multiplier: 1000000
        }
      },
      // paramter_panel[0]: source
      corpus_tab: "new_corpus",
      corpus_name: null,
      //// corpus_tab[0]: new_corpus
      corpuses: [],
      corpuses_valid: true,
      //// corpus_tab[1]: uploaded_corpus
      uploaded_corpuses: [],
      //// corpus_tab[2]: translated
      translateds: [],

      // paramter_panel[2]: command
      purposes: purposes,

      // paramter_panel[3]: lang_pair

      // paramter_panel[4]: field
      selected_field: [],

      // paramter_panel[5]: detail
      lambda: 6.0,

      // paramter_panel[6]: source
      source_tab: "new_file",
      //// source_tab[0]: new_file
      files_valid: true,
      //// source_tab[1]: uploaded_file
      uploaded_files: [],

      // other
      reserve_status_code: 0,
      upload_detail_parm_corpus:{
        target: 'corpus',
        additional: false,
        size: 300,
        count: 200000,
        files: 1
      },
      upload_detail_parm_source:{
        target: 'source',
        additional: true,
        size: 300,
        count: 200000,
        files: 1
      }
    }
  },
  mounted: function() {
    this.set_lang_pair(this.train_lang_pair);
    // preference設定
    if(this.$store.getters.preference
      && this.$store.getters.preference.train){
      var preference = this.$store.getters.preference.train;
      if('purpose' in preference
        && this.$store.getters.user
        && this.$store.getters.user.allowed_purposes
        && this.$store.getters.user.allowed_purposes.indexOf(preference.purpose) >= 0){
        this.parameters.purpose = preference.purpose;
      }
      this.set_lang_pair(preference);
      if(preference.field){
        this.selected_field = [
          preference.field
        ];
      }
      if("detail" in preference){
        for(var key of ["fisher_multiplier"]){
          if(key in preference.detail){
            this.parameters.detail[key] = preference.detail[key];
            if(key === "fisher_multiplier"){
              this.lambda = Math.round(Math.log10(this.parameters.detail[key]) * 10) / 10;
            }
          }
        }
      }
    }
    // queryから取得
    if(this.$route.query.corpus
      && this.$route.query.corpus.match(/^C[0-9]{7}$/)){
      this.corpus_tab = "uploaded_corpus";
      // 対訳名を取得
      this.get_any_names(
        "corpus",
        "cid",
        [this.$route.query.corpus],
        "uploaded_corpuses",
        ["cid", "name", "lang_pair"]
      )
        .then(() => {
          if((!(this.$route.query.source)
            || !(this.$route.query.source.match(/^F[0-9]{8}$/)))
            && this.$refs.corpus_select){
            this.$refs.corpus_select.search_cid = this.$route.query.corpus;
          }
        });
    }
    if(this.$route.query.source_lang
      && this.$route.query.target_lang){
      this.set_lang_pair(this.$route.query);
    }
    if(this.$route.query.field
      && this.$route.query.field.match(/^L[0-9]{6}$/)){
      this.selected_field = [
        this.$route.query.field
      ];
    }
    if(this.$route.query.source
      && this.$route.query.source.match(/^F[0-9]{8}$/)){
      this.source_tab = "uploaded_file";
      // ファイル名を取得
      this.get_any_names(
        "file",
        "fid",
        [this.$route.query.source],
        "uploaded_files",
        ["name", "extensions", "remarks"]
      )
        .then(() => {
          if(this.$refs.file_select){
            this.$refs.file_select.search_fid = this.$route.query.source;
          }
        });
    }
  },
  computed: {
    field_property: function() {
      return function(lid, property){
        var result = lid;
        var lang = this.$i18n.locale;
        if(!this.$store.getters.fields.trainable){
          return result;
        }else if(!this.$store.getters.fields.trainable[lang]){
          lang = "en";
        }
        var lang_pair = this.parameters.source_lang + "_" + this.parameters.target_lang;
        var lid_data = this.$store.getters.fields.trainable[lang][lang_pair];
        if(lid_data && lid_data[lid]){
          result = lid_data[lid][property];
        }
        return result;
      }.bind(this);
    },
    trainable: function(){
      return ((this.corpus_tab === 'new_corpus' && !this.corpuses_valid)
        || (this.corpus_tab === 'uploaded_corpus' && this.uploaded_corpuses.length > 0 && this.uploaded_corpuses.length <= 5)
        || (this.corpus_tab === 'translated' && this.translateds.length > 0 && this.translateds.length <= 5))
        && this.parameters.title.length <= 80
        && this.parameters.source_lang !== ""
        && this.parameters.target_lang !== ""
        && (this.selected_field.length > 0 && this.field_property(this.selected_field[0], 'available'))
        && (this.train_status_code !== 2);
    },
    reserve_status_color: function(){
      var color = "";
      switch(this.reserve_status_code){
        case 0:
          color = "lime"
          break;
        case 1:
          color = "warning"
          break;
        case 2:
          color = "red"
          break;
      }
      return color;
    },
    xlsx_lang_pair: {
      get: function () {
        return {
          source_lang: this.parameters.first_lang,
          target_lang: this.parameters.second_lang
        }
      },
      set: function(new_lang_pair){
        this.parameters.first_lang = new_lang_pair.source_lang;
        this.parameters.second_lang = new_lang_pair.target_lang;
      }
    },
    train_lang_pair: {
      get: function () {
        return {
          source_lang: this.parameters.source_lang,
          target_lang: this.parameters.target_lang
        }
      },
      set: function(new_lang_pair){
        this.parameters.source_lang = new_lang_pair.source_lang;
        this.parameters.target_lang = new_lang_pair.target_lang;
      }
    },
    train_lang_pairs: function(){
      var lang_pairs = this.$store.getters.lang_pairs['trainable'];
      var lang_pair = null;
      if(this.corpus_tab === 'new_corpus'
        && this.get_extension() === 'xlsx'){
        lang_pair = [this.parameters.first_lang, this.parameters.second_lang];
      }else if(this.corpus_tab === 'uploaded_corpus'
        && this.uploaded_corpuses.length > 0
        && "lang_pair" in this.uploaded_corpuses[0]){
        lang_pair = this.uploaded_corpuses[0].lang_pair;
      }else if(this.corpus_tab === 'translated'
        && this.translateds.length > 0
        && "remarks" in this.translateds[0]
        && "source_lang" in this.translateds[0].remarks
        && "target_lang" in this.translateds[0].remarks){
        lang_pair = [this.translateds[0].remarks.source_lang, this.translateds[0].remarks.target_lang];
      }
      if(lang_pair !== null){
        lang_pairs = {};
        var is_change = false;
        if(lang_pair[1] in this.$store.getters.lang_pairs['trainable']
          && this.$store.getters.lang_pairs['trainable'][lang_pair[1]].indexOf(lang_pair[0]) !== -1){
          lang_pairs[lang_pair[1]] = [
            lang_pair[0]
          ];
          if(lang_pair.indexOf(this.parameters.source_lang) < 0
            || lang_pair.indexOf(this.parameters.target_lang) < 0){
            this.parameters.source_lang = lang_pair[1];
            this.parameters.target_lang = lang_pair[0];
            is_change = true;
          }
        }
        if(lang_pair[0] in this.$store.getters.lang_pairs['trainable']
          && this.$store.getters.lang_pairs['trainable'][lang_pair[0]].indexOf(lang_pair[1]) !== -1){
          lang_pairs[lang_pair[0]] = [
            lang_pair[1]
          ];
          if(lang_pair.indexOf(this.parameters.source_lang) < 0
            || lang_pair.indexOf(this.parameters.target_lang) < 0
            || is_change){
            this.parameters.source_lang = lang_pair[0];
            this.parameters.target_lang = lang_pair[1];
            is_change = true;
          }
        }
        if(is_change){
          this.set_field();
        }
      }
      return lang_pairs;
    },
    fisher_multiplier_available: function(){
      return ['develop', 'in-company'].filter(option => (this.$store.getters.enable_options.indexOf(option) >= 0)).length > 0;
    },
    file_remarks: function(){
      if(this.source_tab === 'uploaded_file'
        && this.uploaded_files.length === 1
        && this.uploaded_files[0].remarks
        && this.uploaded_files[0].remarks.similarity){
        var remarks_count = 0;
        for(var xid in this.uploaded_files[0].remarks.similarity){
          var remark = this.uploaded_files[0].remarks.similarity[xid];
          if(remark.type === "corpus"){
            remarks_count++;
          }
        }
        if(remarks_count > 0){
          return this.uploaded_files[0].remarks;
        }
      }
      return null;
    },
    corpus_lang_pair: function(){
      if(this.uploaded_corpuses.length > 0){
        return this.uploaded_corpuses[0].lang_pair;
      }else{
        return null;
      }
    },
    translated_lang_pair: function(){
      if(this.translateds.length > 0
        && this.translateds[0].remarks
        && ('source_lang' in this.translateds[0].remarks)
        && ('target_lang' in this.translateds[0].remarks)){
        return [this.translateds[0].remarks.source_lang, this.translateds[0].remarks.target_lang];
      }else{
        return null;
      }
    }
  },
  methods: {
    make_title: function(panel_name){
      var result = "";
      switch(panel_name){
        case "title":
          if(this.parameters.title){
            return this.parameters.title;
          }
          break;
        case "corpus":
          switch(this.corpus_tab){
            case "new_corpus":
              if(this.$refs.upload_corpus && this.$refs.upload_corpus.files){
                if(Array.isArray(this.$refs.upload_corpus.files)){
                  if(this.$refs.upload_corpus.files.length > 0){
                    result = this.$refs.upload_corpus.files[0].name;
                    if(this.$refs.upload_corpus.files.length > 1){
                      result += ", ...";
                    }
                  }
                }else{
                  result = this.$refs.upload_corpus.files.name;
                }
              }
              break;
            case "uploaded_corpus":
              if(this.uploaded_corpuses && this.uploaded_corpuses.length > 0){
                if(this.uploaded_corpuses[0].name){
                  result = this.uploaded_corpuses[0].name.replace(/\([CF]\d{7,8}\)/g, "")
                         + "(" + this.uploaded_corpuses[0].cid + ")";
                }else{
                  result = this.uploaded_corpuses[0].cid;
                }
                if(this.uploaded_corpuses.length > 1){
                  result += ", ..."
                }
              }
              break;
            case "translated":
               if(this.translateds && this.translateds.length > 0){
                 if(this.translateds[0].name){
                   result = this.translateds[0].name.replace(/\([CF]\d{7,8}\)/g, "")
                          + "(" + this.translateds[0].fid + ")";
                 }else{
                   result = this.translateds[0].cid;
                 }
                 if(this.translateds.length > 1){
                   result += ", ..."
                 }
               }
               break;
          }
          break;
        case "source":
          switch(this.source_tab){
            case "new_file":
              if(this.$refs.upload_source && this.$refs.upload_source.files){
                if(Array.isArray(this.$refs.upload_source.files)){
                  if(this.$refs.upload_source.files.length > 0){
                    result = this.$refs.upload_source.files[0].name;
                    if(this.$refs.upload_source.files.length > 1){
                      result += ", ...";
                    }
                  }
                }else{
                  result = this.$refs.upload_source.files.name;
                }
              }
              break;
            case "uploaded_file":
              if(this.uploaded_files && this.uploaded_files.length > 0){
                if(this.uploaded_files[0].name){
                  result = this.uploaded_files[0].name
                         + "(" + this.uploaded_files[0].fid + ")";
                }else{
                  result = this.uploaded_files[0].fid;
                }
                if(this.uploaded_files.length > 1){
                  result += ", ..."
                }
              }
              break;
          }
          break;
      }
      return result;
    },
    get_any_names: function(type, id_name, id_list, return_val, columns=["name"], with_priority=false){
      return new Promise((resolve, reject) => {
        this.$http.get(this.$store.getters.api_endpoint + "/" + type)
          .then(function(response){
            if(response && "data" in response){
              if(this.$store.getters.debug){
                console.log("response.data:" + JSON.stringify(response.data));
              }
              var selected_results = [];
              var priority = 1;
              for(var id of id_list){
                for(var d of response.data){
                  if(id === d[id_name]){
                    var selected_result = {};
                    selected_result[id_name] = d[id_name];
                    for(var c of columns){
                      if(c in d){
                        selected_result[c] = d[c];
                      }
                    }
                    if(with_priority){
                      selected_result.priority = priority++;
                    }
                    selected_results.push(selected_result);
                    break;
                  }
                }
              }
              this[return_val] = selected_results;
              return resolve(true);
            }
          }.bind(this))
          .catch( error => {
            if(this.http_error(error)){
              this.$store.commit("setNotification", {
                type: "error",
                message: error.response.data
              });
            }
            return resolve(false);
          });
      });
    },
    set_lang_pair: function(lang_pair){
      if('trainable' in this.$store.getters.lang_pairs
        && lang_pair.source_lang in this.$store.getters.lang_pairs['trainable']){
        this.parameters.source_lang = lang_pair.source_lang;
        if(this.$store.getters.lang_pairs['trainable'][this.parameters.source_lang].indexOf(lang_pair.target_lang) !== -1){
          this.parameters.target_lang = lang_pair.target_lang;
        }else if(this.$store.getters.lang_pairs['trainable'][this.parameters.source_lang].length > 0){
          this.parameters.target_lang = this.$store.getters.lang_pairs['trainable'][this.parameters.source_lang][0];
        }else{
          this.parameters.target_lang = "";
        }
      }
    },
    set_field: function(){
      var lang = this.$i18n.locale;
      if(!this.$store.getters.fields.trainable){
        return;
      }
      if(!this.$store.getters.fields.trainable[lang]){
        lang = "en";
      }
      var lang_pair = this.parameters.source_lang + "_" + this.parameters.target_lang;
      var lid_data = this.$store.getters.fields.trainable[lang][lang_pair];
      // 分野が1つしかないものは自動で選択されるようにする
      if(Object.keys(lid_data).length === 2){
        for(var lid in lid_data){
          if(lid !== "root"){
            this.selected_field = [
              lid
            ];
          }
        }
      }else{
        this.selected_field = [];
      }
    },
    get_extension: function(){
      if(this.corpuses.length == 0){
        return "";
      }
      return this.corpuses[0].name.split('.').pop();
    },
    reset_corpus_tab: function(){
      if(this.$refs.upload_corpus){
        this.$refs.upload_corpus.files = null;
      }
      this.uploaded_corpuses = [];
      this.translateds = [];
    },
    reset_source_tab: function(){
      if(this.$refs.upload_source){
        this.$refs.upload_source.files = null;
      }
      this.uploaded_files = [];
    },
  },
  watch: {
    trainable: {
      handler: function (val, oldVal) {
        this.$emit("update_trainable", val);
      }
    }
  }
}
</script>
<style scoped>
.accordion{
  border-radius: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.v-expansion-panel::before{
  box-shadow: none;
}
</style>
